// Curated taxonomy mapping categories → traditions present in the archive.
// New traditions added to seed data should be appended below.
export const CATEGORIES = [
  {
    id: "religion",
    title: "Religious Traditions",
    blurb: "Christianity, Vedanta, Buddhism, Vedic scripture, Hebrew scripture, Tibetan Buddhism.",
    traditions: [
      "Christianity", "Vedanta", "Buddhism", "Tibetan Buddhism",
      "Vedic", "Hebrew Scripture", "Genesis",
    ],
  },
  {
    id: "esoteric",
    title: "Esoteric & Occult",
    blurb: "Hermeticism, Kabbalah, Alchemy, Gnosticism, Theosophy — the inner streams.",
    traditions: [
      "Hermeticism", "Kabbalah", "Alchemy", "Alchemy (Western)",
      "Gnosticism", "Theosophy / Vedanta",
    ],
  },
  {
    id: "spiritual",
    title: "Spiritual & Mystical Systems",
    blurb: "Sufism, Taoism, Tantra, and the lived mystical paths.",
    traditions: ["Sufism", "Taoism", "Tantra"],
  },
  {
    id: "ancient",
    title: "Ancient Texts & Philosophy",
    blurb: "Stoicism, Platonism, Greek mystery, Norse cosmology, Latin philosophy.",
    traditions: [
      "Stoicism", "Greek Philosophy", "Platonism", "Plato",
      "Greek Mystery", "Greek", "Norse", "Latin", "Chinese Cosmology",
    ],
  },
  {
    id: "hidden",
    title: "Hidden History & Redacted",
    blurb: "Declassified disclosures, suppressed apocrypha, the deliberately forgotten.",
    traditions: ["Redacted Texts", "Declassified (Speculative)"],
  },
  {
    id: "science",
    title: "Science & Psychology",
    blurb: "Jung, depth psychology, modern physics, speculative cosmology — the new vocabularies.",
    traditions: [
      "Modern Psychology", "Jungian Psychology", "Depth Psychology",
      "Modern Physics", "Modern Physics (Speculative)",
      "Modern Science (Parallel)", "Modern Science (Speculative parallel)",
      "Modern Cosmology (Speculative)",
    ],
  },
  {
    id: "indigenous",
    title: "Indigenous & Earth Wisdom",
    blurb: "Shamanism, Mesoamerican, Polynesian, Aboriginal Australian — the elder cosmologies.",
    traditions: [
      "Siberian Shamanism", "Shamanism", "Mesoamerican",
      "Polynesian", "Indigenous Australian",
    ],
  },
];

export function conceptMatchesCategory(concept, category) {
  if (!category) return true;
  if (category.id === "all" || !category.traditions?.length) return true;
  const set = new Set(category.traditions);
  return (concept.traditions || []).some((t) => set.has(t.tradition));
}
